import React from 'react';

/** Compact data display cell — inherits font from parent container's style.
 *
 *  ELV-1 — accepts an optional `data-testid` so individual cells can
 *  be targeted in tests (e.g. the elevation rows in the Site Boundary
 *  accordion need testids per resolution source). */
type DataCellProps = {
  label: string;
  value: string;
  highlight?: boolean;
  'data-testid'?: string;
};

const DataCell = React.memo(({ label, value, highlight, ...rest }: DataCellProps) => (
  <div className="space-y-0.5" data-testid={rest['data-testid']}>
    <div className="text-[9px] font-bold text-text-secondary uppercase tracking-widest">{label}</div>
    <div className={`text-xs ${highlight ? 'text-danger font-bold' : 'text-text-primary'}`}>{value}</div>
  </div>
));

DataCell.displayName = 'DataCell';

export { DataCell };
